<template>
  <div class="content">
    <div class="columns" style>
      <div class="column">
        <h3 style="margin-bottom: 5px; font-variant: all-petite-caps">
          {{ acc && acc.name ? acc.name : "" }}
          {{ acc && acc.mask ? acc.mask : "" }}
        </h3>
        <p style="margin-bottom: 5px; font-variant: all-petite-caps">
          {{ blaData.items[0].institution_name }}
        </p>
        <p
          style="margin-bottom: 20px; font-variant: all-petite-caps"
          v-if="acc && acc.subtype"
        >
          {{ acc.subtype }}
        </p>
        <p style="margin-bottom: 0px" v-if="acc && acc.owner">
          Owner: {{ acc.owner }}
        </p>
        <p style="margin-bottom: 0px">Data Source: Plaid</p>
        <p>Data Refreshed: {{ datePulled }}</p>
      </div>

      <div class="column" style="text-align: right">
        <h4 style="color: grey">{{ mon }}</h4>
        <p style="color: grey" v-if="acc && acc.ocr">
          Total Deposits: ${{ numberWithCommas(acc.total_deps, true) }}
          <br />Total Withdrawals: ${{
            numberWithCommas(acc.total_with, true)
          }}
          <br />ADB: ${{ numberWithCommas(acc.adb, true) }} <br />NEDs:
          {{ acc.neds }} <br />NSFs: {{ acc.nsfs }}
        </p>

        <!-- <p
          style="color: grey"
        >ADB: ${{numberWithCommas(adb, true)}} - Based on {{bizdays}} Business Days</p> -->
      </div>
    </div>

    <hr />
    <div v-for="(day, idx) in days" v-bind:key="'day' + idx">
      <div>
        <div v-if="txForDate(day.date).length > 0">
          <!-- Your table content -->
          <div
            class="columns"
            v-for="(tx, tidx) in txForDate(day.date)"
            v-bind:key="'day' + idx + 'tx' + tidx"
          >
            <div class="column is-one-fifth">{{ formatDate(day.date) }}</div>
            <div class="column">{{ tx.original_description }}</div>
            <div class="column is-one-fifth" style="text-align: right">
              {{ numberWithCommas(-1 * tx.amount, true) }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="columns"
        style="
          text-weight: bold;
          background: #3c5cac;
          color: white;
          margin: 10px 0px; ;
        "
        v-if="idx > 0"
      >
        <div class="column">{{ formatDate(day.date) }}</div>
        <div class="column" style="text-align: center"></div>
        <div class="column" style="text-align: right">
          Ending balance: {{ numberWithCommas(day.current) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Input from "@/components/shared/Input";
import moment from "moment";
export default {
  name: "Statements",
  components: {},
  props: {
    model: String,
    account: String,
    month: String,
  },
  data() {
    return {};
  },
  computed: {
    blaData: function () {
      let r = this.model;
      r = JSON.parse(r);
      console.log(r);
      r = JSON.parse(r.plaid).report;
      console.log(r);
      return r;
    },
    ocr: function () {
      let r = this.model;
      r = JSON.parse(r);
      console.log(r);
      r = JSON.parse(r.ocr);
      console.log(r);
      return r;
    },
    acc: function () {
      let self = this;

      let total_deps = 0;
      let total_with = 0;
      let adb = 0;
      let nsfs = 0;
      let neds = 0;
      for (var i = 0; i < this.blaData.items[0].accounts.length; i++) {
        var acc = this.blaData.items[0].accounts[i];
        if (acc.account_id == this.account) {
          if (this.ocr && this.ocr.response.bank_accounts) {
            this.ocr.response.bank_accounts.forEach((a) => {
              if (a.account_number === acc.mask) {
                acc.ocr = a;
                let daysinmonth = moment(self.month, "YYYY-MM").daysInMonth();
                let startofmonth = moment(self.month + "-01");
                let endofmonth = moment(startofmonth).endOf("month");

                let slashformat = moment(self.month, "YYYY-MM").format(
                  "MM/YYYY"
                );

                console.error(
                  "PLAID OCR MATCH",
                  slashformat,
                  a.average_daily_balance_by_month,
                  startofmonth,
                  endofmonth
                );
                if (
                  a.average_daily_balance_by_month &&
                  a.average_daily_balance_by_month[slashformat]
                ) {
                  adb = a.average_daily_balance_by_month[slashformat];
                }

                if (
                  a.negative_balances_by_month_weekday &&
                  a.negative_balances_by_month_weekday[slashformat]
                ) {
                  neds =
                    a.negative_balances_by_month_weekday[slashformat].length;
                }

                if (a.nsf_count_by_month && a.nsf_count_by_month[slashformat]) {
                  nsfs = a.nsf_count_by_month[slashformat];
                }
                acc.owner = null;

                acc.owners.forEach((owner) => {
                  if (!owner.names) {
                    return;
                  }
                  owner.names.forEach((name) => {
                    if (!acc.owner) {
                      acc.owner = name;
                    }
                  });
                });

                acc.transactions.forEach((tx) => {
                  //check if tx is on this month

                  if (
                    moment(tx.date).isSameOrAfter(startofmonth) &&
                    moment(tx.date).isSameOrBefore(endofmonth)
                  ) {
                    if (tx.amount < 0) {
                      total_deps += parseFloat(tx.amount) * -1;
                    }

                    if (tx.amount > 0) {
                      total_with += parseFloat(tx.amount);
                    }
                  }
                });
              }
            });
          }

          return {
            ...acc,
            total_deps: total_deps,
            total_with: total_with,
            adb: adb,
            neds: neds,
            nsfs: nsfs,
          };
        }
      }

      return null;
    },
    mon: function () {
      return moment(this.month, "YYYY-MM").format("MMMM YYYY");
    },
    days: function () {
      var arr = [];
      try {
        for (var i = 0; i < this.acc.historical_balances.length; i++) {
          var day = this.acc.historical_balances[i];
          if (day.date.indexOf(this.month) > -1) {
            arr.push(day);
          }
        }
      } catch (err) {
        console.log("days error", err);
      }

      return arr.reverse();
    },
    bizdays: function () {
      var sum = 0;
      for (var i = 0; i < this.days.length; i++) {
        var day = this.days[i].date;
        var m = moment(day, "YYYY-MM-DD");
        // if (m.day() != 0 && m.day() != 6) {
        sum++;
        // }
      }
      return sum;
    },
    adb: function () {
      var sum = 0;
      for (var i = 1; i < this.days.length; i++) {
        var day = this.days[i];
        sum += day.current;
      }
      return sum / this.bizdays;
    },
    datePulled: function () {
      return moment(this.blaData.date_generated).format("llll");
    },
  },
  methods: {
    txForDate: function (date) {
      var arr = [];
      for (var i = 0; i < this.acc.transactions.length; i++) {
        var tx = this.acc.transactions[i];
        if (tx.date == date) {
          arr.push(tx);
        }
      }
      return arr;
    },
    getVal(obj, key) {
      if (this.model && this.model[obj] && this.model[obj][key]) {
        return this.model[obj][key];
      }
      return "";
    },
    formatUnixTS(ts) {
      // console.log("formatting", ts);
      return moment.unix(ts).format("l LT");
    },
    formatUnixDate(ts) {
      // console.log("formatting", ts);
      return moment.unix(ts).format("l");
    },
    formatDate(date) {
      // console.log("formatting", ts);
      let d = moment(date, "YYYY-MM-DD").format("l");
      if (d == "Invalid date") {
        return "-";
      }
      return d;
    },
    numberWithCommas(val, money = true) {
      if (money) val = parseFloat(val).toFixed(2);
      var returnval = null;
      if (val != null)
        returnval = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (returnval == "NaN") returnval = "0.00";

      return returnval;
    },
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
    prev() {
      this.loading = true;
      this.$emit("prev", this.$data);
    },
    scrollY() {
      this.scroll = window.top.scrollY;
      // console.log(this.scroll)
    },
  },
  mounted: function () {
    var self = this;
    window.addEventListener("scroll", this.scrollY);
    // self.$router.push({ path: `/docgenerator/` });
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.scrollY);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-floating {
  top: 0px;
  transform: scale(0.9) translateY(80px);
  box-shadow: 0px 4px 19px -8px #cbc1c1;
  width: 100%;
}
.header-floating-open {
  top: -15px;
  transform: scale(0.9) translateY(90px);
  box-shadow: 0px 4px 19px -8px #cbc1c1;
  width: 100%;
}
.floating {
  top: 0px;
  transform: translateY(0px) translateX(-10px);
  box-shadow: 0px 4px 19px 0px #cbc1c1;
  width: 100%;
}
.incomplete-row {
  background: #ececec;
  opacity: 0.3;
}
.title-cell {
  /* background: #f0f0f0; */
  background: #f8fbff;
  text-align: right;
}
.creditor {
  padding: 10px;
}
.title-name {
  font-size: 1.2rem;
  margin-top: 0px !important;
  font-weight: 400;
}
.columns {
  margin-bottom: 0px;
}
</style>
